var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#40C706",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.009-7c-.662 0-1.198.637-1.198 1.423V14.09l-2.742-3.274c-.482-.558-1.254-.545-1.724.028-.47.574-.459 1.492.024 2.05l4.79 5.694c.113.13.248.231.395.299.29.152.62.152.91 0 .146-.068.28-.17.395-.3l4.789-5.693c.47-.558.47-1.463 0-2.021-.47-.558-1.23-.558-1.7 0l-2.742 3.217V-5.577c0-.786-.536-1.423-1.197-1.423z",
    transform: "translate(-278 -1705) translate(0 1337) translate(118 168) translate(0 130) translate(0 30) translate(20 29) translate(130 11.339) rotate(-90 23 6)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrow-green.c714e1967f8fcac21f1da5f30c7e950e.svg";
export { ForwardRef as ReactComponent };